const MAX_SUBSCRIPTIONS_NUM_PER_USER = 10;

const exportedConfigs = {
    MAX_SUBSCRIPTIONS_NUM_PER_USER,
};

export default exportedConfigs;
